import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "aura-header flex flex-wrap items-center justify-between gap-3 border-b border-[#E5E5E5] bg-white px-4 py-3 shadow-[0px_1px_3px_rgba(0,0,0,0.1),0px_1px_2px_-1px_rgba(0,0,0,0.1)] sm:px-6 sm:py-4" }
const _hoisted_2 = { class: "aura-header-brand flex items-center gap-2" }
const _hoisted_3 = { class: "aura-header-title flex items-center gap-2 rounded-full bg-[#E6F9F5] px-3 py-1.5" }
const _hoisted_4 = { class: "text-sm font-bold uppercase tracking-wider text-[#242B59]" }
const _hoisted_5 = { class: "aura-header-controls flex items-center gap-2 sm:gap-4" }
const _hoisted_6 = { class: "aura-header-date-picker hidden w-64 sm:block" }
const _hoisted_7 = { class: "aura-header-mobile-date w-full sm:hidden" }
const _hoisted_8 = {
  key: 0,
  class: "aura-active-filters flex flex-wrap gap-2 rounded border-t border-gray-200 bg-gray-50 p-2 ring-1 ring-gray-300"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiDatePicker = _resolveComponent("UiDatePicker")!
  const _component_UiBadge = _resolveComponent("UiBadge")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createCommentVNode(" Left: Branding "),
      _createElementVNode("div", _hoisted_2, [
        ($setup.props.showMenu && $setup.props.compact)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "-ml-1 rounded-lg p-2 text-[#242B59] transition-colors hover:bg-[#F5F6F8] focus:outline-none focus:ring-2 focus:ring-[#48DDC3]",
              "aria-label": "Abrir histórico de conversas",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.emit('menu')))
            }, [
              _createVNode($setup["MenuIcon"], { class: "h-6 w-6" })
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_3, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "h-2 w-2 rounded-full bg-[#48DDC3]" }, null, -1 /* CACHED */)),
          _createElementVNode("span", _hoisted_4, _toDisplayString($setup.props.verticalName || $setup.t('aura.chat.title')), 1 /* TEXT */)
        ])
      ]),
      _createCommentVNode(" Right: Period (inline like CallPage) + Filters "),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_UiDatePicker, {
            modelValue: $setup.dateRange,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.dateRange) = $event)),
            range: "",
            multiCalendars: "",
            "min-date": $setup.minimumSelectableDate,
            "max-date": $setup.maximumSelectableDate
          }, null, 8 /* PROPS */, ["modelValue", "min-date", "max-date"])
        ]),
        _createCommentVNode(" Filters in side panel "),
        _createVNode($setup["AuraFilters"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_UiDatePicker, {
          modelValue: $setup.dateRange,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.dateRange) = $event)),
          range: "",
          "multi-calendars": false,
          "min-date": $setup.minimumSelectableDate,
          "max-date": $setup.maximumSelectableDate
        }, null, 8 /* PROPS */, ["modelValue", "min-date", "max-date"])
      ])
    ]),
    _createCommentVNode(" Active Filters Display - copied from CallPage line 312-328 "),
    ($setup.visibleActiveFilters.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.visibleActiveFilters, (filter) => {
            return (_openBlock(), _createBlock(_component_UiBadge, {
              key: filter.field,
              removable: "",
              onRemove: ($event: any) => ($setup.handleRemoveFilter(filter.field as keyof AuraFiltersType))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(filter.name) + ": " + _toDisplayString(filter.label), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onRemove"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}